import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class PdfExportService {

  private isExportingPdf = false;
  private readyReportCounter = 0;
  public triggerIncrementReportReady: EventEmitter<number>;
  public imagedLoadedTrigger: EventEmitter<any>;

  public imageLoadedCounter: object = {};
  private listReadyReports = [];

  constructor() {
    this.triggerIncrementReportReady = new EventEmitter<number>();
    this.imagedLoadedTrigger = new EventEmitter<any>();
  }

  public updateExportingPdf(isExportingPdf: boolean) {
    this.isExportingPdf = isExportingPdf;
  }

  public resetImageCounter() {
    this.imageLoadedCounter = {};
  }

  public resetListReadyReport() {
    this.listReadyReports = [];
    this.readyReportCounter = 0;
  }

  get exportingPdf() {
    return this.isExportingPdf;
  }

  public incrementNumberReportReady(component) {
    // prevent duplicate component ready
    if (this.listReadyReports.indexOf(component) < 0) {
      this.readyReportCounter++;
      this.triggerIncrementReportReady.emit(this.readyReportCounter);
      this.listReadyReports.push(component);
    }
  }

  public updateNumberImageLoaded(component: string) {
    let currentCounter = this.imageLoadedCounter[component];
    if (!currentCounter) {
      // inital counter value
      currentCounter = 1;
    } else {
      currentCounter += 1;
    }
    this.imageLoadedCounter[component] = currentCounter;
    this.imagedLoadedTrigger.emit({
      component,
      currentCounter
    });
  }

  get numberReportReady() {
    return this.readyReportCounter;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/export-pdf/pdf-export.service.ts